// Topbar enxuto: hamburger em mobile + indicador de endpoint+target ativo + status.

import { useEffect, useState } from 'preact/hooks';
import { active, activeEndpoint, activeToken, activeUrl, sidebarOpen } from '../store/global';
import { health } from '../lib/api';
import { shortHost } from '../lib/format';

export function Topbar() {
  const [healthy, setHealthy] = useState<'unknown' | 'ok' | 'down'>('unknown');

  useEffect(() => {
    if (!activeUrl.value || !activeToken.value) {
      setHealthy('unknown');
      return;
    }
    let alive = true;
    health()
      .then(() => alive && setHealthy('ok'))
      .catch(() => alive && setHealthy('down'));
    return () => {
      alive = false;
    };
  }, [activeUrl.value, activeToken.value]);

  const ep = activeEndpoint.value;
  const ref = active.value;
  // Encurta URL em mobile: sem protocolo; tira o sufixo `.ai.blips.com.br` ou,
  // se o host for de outro domínio, fica só com o primeiro label DNS.
  const epLabel = ep ? ep.url.replace(/^https?:\/\//, '') : null;
  const epLabelShort = epLabel ? shortHost(epLabel) : undefined;

  const dotColor =
    healthy === 'ok' ? 'bg-success' : healthy === 'down' ? 'bg-destructive' : 'bg-muted-foreground';

  return (
    <header class="h-14 border-b border-border bg-background flex items-center gap-2 sm:gap-3 px-3 sm:px-4 shrink-0">
      <button
        class="inline-flex items-center justify-center size-8 -ml-1 rounded-md hover:bg-accent focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 md:hidden"
        onClick={() => (sidebarOpen.value = true)}
        aria-label="Abrir menu"
      >
        <i class="ph ph-list text-xl" />
      </button>

      <div class="flex items-center gap-2 text-xs text-muted-foreground min-w-0">
        <span class={`size-2 rounded-full shrink-0 ${dotColor}`} />
        <span class="font-mono truncate hidden sm:inline">{epLabel ?? 'sem endpoint'}</span>
        <span class="font-mono truncate sm:hidden">{epLabelShort ?? 'sem endpoint'}</span>
      </div>

      {ref && ep && (
        <>
          <div class="h-6 w-px bg-border hidden sm:block" />
          <div class="flex items-center gap-1.5 text-sm min-w-0">
            <i
              class={`ph ${ref.isTeam ? 'ph-tree-structure' : 'ph-user'} text-sm text-muted-foreground shrink-0`}
            />
            <span class="font-medium truncate">{ref.targetId}</span>
            <span class="text-[11px] text-muted-foreground font-mono hidden md:inline">
              {ref.isTeam ? 'team' : 'agent'}
            </span>
          </div>
        </>
      )}

      <div class="flex-1" />

      {!ref && (
        <div class="text-xs text-muted-foreground hidden md:block">
          Selecione um endpoint e agente na sidebar para começar.
        </div>
      )}
    </header>
  );
}
